import '../../styles/index.scss';

import { graphql } from 'gatsby';
import { PropTypes } from 'prop-types';
import React from 'react';

import Header from '../../components/Header';
import Metadata from '../../components/Metadata';
import Story from '../../components/Story';
import { COLORS } from '../../constants/colors';
import { toCamelCase } from '../../utils';

const StoryTemplate = (props) => {
  const {
    data: { contentfulStory },
    location,
  } = props;
  const { color, metadata, publishedDate } = contentfulStory;

  const fallbackMetadata = {
    title: contentfulStory.articleTitle,
  };

  return (
    <>
      <Metadata
        created={publishedDate}
        data={metadata || fallbackMetadata}
        location={location}
      />
      <div className="story">
        <Header
          backgroundColor="#ffffff00"
          showOverlayMode
          textColor={COLORS[toCamelCase(color)]}
        />
        <Story data={contentfulStory} location={location} />
      </div>
    </>
  );
};

StoryTemplate.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};

export default StoryTemplate;

export const query = graphql`
  query ($slug: String) {
    contentfulStory(slug: { eq: $slug }) {
      publishedDate
      metadata {
        ...ContentfulMetadataFragment
      }
      internal {
        type
      }
      storyHeader: header
      
      articleTitle
      image {
        ...ContentfulBaseImageFragment
      }
      slug
      subHeader
      title
      tags {
        name
        slug
        type
      }
      photographyCredits {
        name
        slug
      }
      relatedLinks {
        ... on Node {
          ... on ContentfulArticleLongForm {
            title
            slug
            internal {
              type
            }
          }
          ... on ContentfulStory {
            title
            slug
            internal {
              type
            }
          }
          ... on ContentfulArticleList {
            title
            slug
            internal {
              type
            }
          }
        }
      }
      color
      body {
        ... on ContentfulStoryBody01FullText {
          fullText {
            fullText
          }
          internal {
            type
          }
        }
        ... on ContentfulStoryBody02FullImage {
          image {
            ...ContentfulBaseImageFragment
          }
          imageMobile {
            ...ContentfulBaseImageFragment
          }
          internal {
            type
          }
        }
        ... on ContentfulStoryBody03TextImage {
          text
          image {
            ...ContentfulBaseImageFragment
          }
          format
          internal {
            type
          }
        }
      }
    }
  }
`;
